import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useParams } from 'react-router-dom';
import { Grid, Box, useTheme, useMediaQuery, makeStyles } from '@material-ui/core';

import { useStores } from '../../hooks/use-stores';
import { filterItems } from '../../utils/productFilter';

import Loader from '../../components/Loader';
import ProductCard from '../../components/ProductCards/ProductCard';
import BackLink from '../../components/UI/BackLink';
import ProductFilter from '../../components/ProductFilter/ProductFilter';

const Category = observer(() => {
    const classes = useStyles();
    const { ProductStore: store, HeaderStore } = useStores();
    const { categoryId } = useParams();
    const theme = useTheme();
    const isMD = useMediaQuery(theme.breakpoints.down('md'));
    const filteredProducts = filterItems(store.filters, store.products);

    // Effects
    useEffect(() => {
        store.getProducts(categoryId);

        return () => {
            store.resetStore();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        HeaderStore.setTitle(store.categoryName);
    }, [HeaderStore, store.categoryName]);

    // Sorting
    function descendingComparator(a, b, orderBy) {
        const filterA = parseInt(a.filterProps[orderBy]);
        const filterB = parseInt(b.filterProps[orderBy]);

        if (filterB < filterA) {
            return -1;
        }
        if (filterB > filterA) {
            return 1;
        }

        return 0;
    }

    function getComparator(order, orderBy) {
        return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
    }

    function stableSort(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        return stabilizedThis.map(el => el[0]);
    }

    const sort = products => {
        const liftingCapacityIsAvailable = products.filter(product => product.filterProps?.liftingCapacity !== '').length;

        if (liftingCapacityIsAvailable) {
            return stableSort(products, getComparator('asc', 'liftingCapacity'));
        }

        return products;
    };

    // Renders
    return (
        <div className="category">
            <BackLink to="/catalog" title="Каталог" />
            <ProductFilter />

            {store.loading && <Loader />}

            {!store.loading && (
                <Box mb={{ xxs: 6, lg: 9 }} className={classes.categoryGridWrap} style={{ opacity: store.filterLoading ? 0.5 : 1 }}>
                    <Grid container spacing={isMD ? 3 : 5}>
                        {sort(filteredProducts).map(item => (
                            <Grid item xs={12} sm={6} md={4} key={item.id}>
                                <ProductCard data={item} onToggleFavorite={store.toggleFavorite} propNames={store.propNames} />
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            )}
        </div>
    );
});

const useStyles = makeStyles(theme => ({
    categoryGridWrap: {
        transition: 'opacity .3s ease',
    },
}));

export default Category;
